import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { obterPendenciasOcorrenciasFamilia, obterPendenciasOcorrenciasFamiliaRL } from '../../api/familiaAPI';
import { RootState } from '../../app/store';

export interface PendenciaOcorrencia {
  numeroFamiliar: number;
  pendenciasOcorrenciasFamilia: any[];
  pendenciasOcorrenciasPessoas: PendenciaOcorrenciaPessoaDetalhe[];
  quantidadePendencias: number;
}

export interface PendenciaOcorrenciaPessoaDetalhe {
  idPessoa: number;
  nomePessoa: string;
  tipoRelacaoParentescoRF: { codigo: number, nome: string };
  pendenciasOcorrenciasPessoa: any[];
}

export interface ConsultaPendenciasState {
  pendenciaOcorrencia: PendenciaOcorrencia | null;
  mostrarModalPendencias: boolean;
}

const initialState: ConsultaPendenciasState = {
  pendenciaOcorrencia: null,
  mostrarModalPendencias: true,
};

export const getPendenciasOcorrenciasFamilia = createAsyncThunk(
  'consultaPendencias/getPendenciasOcorrenciasFamilia',
  async (data: {idPessoa: number, numeroFamiliar: number}) => {
    return obterPendenciasOcorrenciasFamilia(data.idPessoa, data.numeroFamiliar);
  }
);

export const getPendenciasOcorrenciasFamiliaRL = createAsyncThunk(
  'consultaPendencias/getPendenciasOcorrenciasFamiliaRL',
  async (data: {idRL: number, numeroFamiliar: number}) => {
    return obterPendenciasOcorrenciasFamiliaRL(data.idRL, data.numeroFamiliar);
  }
);

export const consultaPendenciasSlice = createSlice({
  name: 'consultaPendencias',
  initialState,
  reducers: {
    setMostrarModalPendencias: (state, action) => {
      state.mostrarModalPendencias = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getPendenciasOcorrenciasFamilia.fulfilled, (state, action) => {
      state.pendenciaOcorrencia = action.payload;
    });
    builder.addCase(getPendenciasOcorrenciasFamiliaRL.fulfilled, (state, action) => {
      state.pendenciaOcorrencia = action.payload;
    });
  },
});

export const { setMostrarModalPendencias } = consultaPendenciasSlice.actions;

export const selectPendenciaOcorrencia = (state: RootState) =>
  state.consultaPendencias.pendenciaOcorrencia;
export const selectMostrarModalPendencias = (state: RootState) =>
  state.consultaPendencias.mostrarModalPendencias;

export default consultaPendenciasSlice.reducer;
